/** RoSy prefix-search vs substring-search threshold (queries shorter than this use prefix ILIKE). */
export const ROSY_SEARCH_MIN_LENGTH = 3;

export const toRosySearchQuery = (text: string): string | undefined => {
  const trimmed = text.trim();
  return trimmed.length >= ROSY_SEARCH_MIN_LENGTH ? trimmed : undefined;
};

export const isIncompleteRosySearch = (text: string): boolean => {
  const trimmed = text.trim();
  return trimmed.length > 0 && trimmed.length < ROSY_SEARCH_MIN_LENGTH;
};
